export default __webpack_public_path__ + "static/media/SWT1180.34I-43204_-25828_0.c123fcc4.jpg";